import { useTranslation } from 'react-i18next';
import { Icon, Button } from '@weezevent/nacre';
import useAppContext from '../../../../../../../context/useAppContext';
import ModalSeatsCategory from './ModalSeatsCategory';
import ModalSeatsBody from './ModalSeatsBody';
import LoadingCard from '../../../../../../../components/loadingCard';
import css from '../modal-popup.module.css';
import React from 'react';

export default function ModalSeats({
    availability,
    previousZone,
    seats,
    categories,
    currency,
    inventories,
    sync,
    rates,
    onClose,
    setSeatModalMode = () => {},
    onAddAttendee,
    onSetRates,
    currentInventory
}) {
    const { t } = useTranslation();
    const [seatsAndRates, setSeatsAndRates] = React.useState([]);
    const [{ event, organization }] = useAppContext();
    const [loading, setLoading] = React.useState(false);

    const handleAdd = React.useCallback(() => {
        setLoading(true);
        onAddAttendee(false, seatsAndRates);
        setSeatModalMode(false);
    }, [onAddAttendee, seatsAndRates, setSeatModalMode, setLoading, sync, organization, event, currentInventory, availability]);

    const onSelectRatesWithSeats = React.useCallback(
        seatAndRatesTmp => {
            // Select seats with associated rates
            setSeatsAndRates(seatAndRatesTmp);
            let rates = seatAndRatesTmp.map(seatsAndRate => seatsAndRate.rate).filter(rate => rate);
            onSetRates(rates, currentInventory);
        },
        [setSeatsAndRates, seatsAndRates, onSetRates, currentInventory]
    );

    React.useEffect(() => {
        // construct seatAndRates with no rates to attribute on each attendees his own rate
        let seatsAndRatesTmp = seats.map(seat => {
            return {
                rate: null,
                seat: seat,
                inventory: currentInventory
            };
        });
        setSeatsAndRates(seatsAndRatesTmp);
    }, [seats, setSeatsAndRates, currentInventory]);

    return (
        <div className={css['modal-popup-container']}>
            <div className={css['modal-popup']} zone-info>
                <div className={css['modal-popup-header']}>
                    <div className={css['modal-popup-header-title']}>
                        {seats?.length > 1 ? t('seats_selected_plural', { seatsCount: seats?.length }) : t('seats_selected', { seatsCount: seats?.length })}
                    </div>
                    <Icon className={css['modal-popup-header-toggle']} name="cross" onClick={onClose} size="regular" />
                </div>

                <div className={css['modal-popup-body']}>
                    {loading ? (
                        <LoadingCard loading />
                    ) : (
                        <>
                            <ModalSeatsCategory zone={availability} />
                            <ModalSeatsBody
                                zone={availability}
                                previousZone={previousZone}
                                seats={seats}
                                inventories={inventories}
                                currentInventory={currentInventory}
                                categories={categories}
                                currency={currency}
                                rates={rates}
                                seatsAndRates={seatsAndRates}
                                onSelectRate={onSelectRatesWithSeats}
                            />
                        </>
                    )}
                </div>

                <div className={css['modal-popup-footer']}>
                    <Button
                        fluid
                        primary
                        disabled={seatsAndRates.some(seatAndRate => seatAndRate.rate === null) || loading}
                        onClick={handleAdd}
                        label={t(`ticket.common.action.save`)}
                    />
                </div>
            </div>
        </div>
    );
}
